import React from 'react';
import { motion } from 'framer-motion';

const Card = ({
  children,
  title,
  className = '',
  titleClassName = '',
  // width overrides (defaults preserve your current look)
  maxWidth = 'max-w-[590px]',
  minWidth = 'min-w-[360px] md:min-w-[590px]',
}) => {
  return (
    <motion.div
      initial={{ scale: 0.8, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ duration: 0.5 }}
      className={`w-full ${minWidth} ${maxWidth} p-10 bg-white shadow-xl rounded-2xl mb-10 ${className}`}
    >
      {!!title && (
        <h3 className={`text-3xl font-semibold mb-10 ${titleClassName}`}>
          {title}
        </h3>
      )}
      {children}
    </motion.div>
  );
};

export default Card;